export interface MenuItem {
  id: string;
  icon: string;
  label: string;
  positionClass: string; // Tailwind arbitrary values for positioning
  size?: 'normal' | 'large';
}

// Layout: 3 icons on left, 3 icons on right.
// Ordered relative to the Center Button (Magic Button).
// 
// Visual Order requested (Left to Right on screen):
// 1. Menu Hamburger (Outer Left)
// 2. AI (Middle Left)
// 3. Notifications (Inner Left)
// [MAGIC BUTTON]
// 4. Community (Inner Right)
// 5. Profile (Middle Right)
// 6. Add + (Outer Right)

export const MENU_ITEMS: MenuItem[] = [
  // 1. Inner Left (Visual Position: 3rd from left) -> Notifications
  {
    id: 'notifications',
    icon: 'notifications', // or 'chat' if preferred
    label: 'Alertas',
    positionClass: 'bottom-[34px] right-[calc(50%+50px)]',
    size: 'normal',
  },
  // 2. Inner Right (Visual Position: 4th from left, 1st on right) -> Community
  {
    id: 'community',
    icon: 'groups',
    label: 'Comunidade',
    positionClass: 'bottom-[34px] left-[calc(50%+50px)]',
    size: 'normal',
  },
  // 3. Middle Left (Visual Position: 2nd from left) -> AI
  {
    id: 'ai',
    icon: 'auto_awesome', // Standard icon for AI/Sparkles
    label: 'IA',
    positionClass: 'bottom-[34px] right-[calc(50%+88px)]',
    size: 'normal',
  },
  // 4. Middle Right (Visual Position: 5th from left, 2nd on right) -> Profile
  {
    id: 'profile',
    icon: 'person',
    label: 'Perfil',
    positionClass: 'bottom-[34px] left-[calc(50%+88px)]',
    size: 'normal',
  },
  // 5. Outer Left (Visual Position: 1st from left) -> Menu Hamburger
  {
    id: 'menu',
    icon: 'menu',
    label: 'Menu',
    positionClass: 'bottom-[34px] right-[calc(50%+126px)]',
    size: 'normal',
  },
  // 6. Outer Right (Visual Position: 6th from left, 3rd on right) -> Plus (+)
  {
    id: 'create',
    icon: 'add',
    label: 'Criar',
    positionClass: 'bottom-[34px] left-[calc(50%+126px)]',
    size: 'normal',
  },
];